import React, { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import history from 'utils/history';
import useDeviceDetect from 'utils/useDeviceDetect';

// styles
import './style.scss';

// antd component
import { Button, Modal } from 'antd';

//assets
import {
  ArrowLeftOutlined,
  CloseOutlined,
  QuestionOutlined,
} from '@ant-design/icons';

function InfoModal({
  title,
  content,
  hideButton,
  isOpen,
  // actions
  setOpen,
  // default
  children,
  className,
}) {
  const childClassName = classNames('info-modal-wrapper', className);
  const { isMobile } = useDeviceDetect();

  const closeModal = () => {
    setOpen(false);
  };
  const openModal = () => {
    setOpen(true);
  };

  return (
    <div className={childClassName}>
      {!hideButton && (
        <Button className="info-modal-wrapper__modal-btn" onClick={openModal}>
          <QuestionOutlined />
        </Button>
      )}

      <Modal
        className="create-absence"
        title={
          <>
            {isMobile && (
              <>
                <div className="info-modal__mobile-menu" />
              </>
            )}
            {!!title && <div className="modal-title">{title}</div>}
          </>
        }
        open={isOpen}
        closeIcon={
          <span className="info-modal__close" onClick={closeModal}>
            {!isMobile ? (
              <>
                <CloseOutlined /> Close
              </>
            ) : (
              <ArrowLeftOutlined />
            )}
          </span>
        }
        onCancel={closeModal}
        footer={[]}
      >
        {!!content && (
          <div
            className="info-modal__content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
        {!!children && <div className="info-modal__content">{children}</div>}
      </Modal>
    </div>
  );
}

InfoModal.defaultProps = {
  isOpen: false,
  hideButton: false,
  title: 'Title',
  content: false,
};

InfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default memo(InfoModal);
